import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Step1InputForm from "../../components/payment/Step1InputForm";
import Step2Payment from "../../components/payment/Step2Payment";
import Step3BankTransfer from "../../components/payment/Step3BankTransfer";
import Step4Complete from "../../components/payment/Step4Complete";

type PaymentStep = 1 | 2 | 3 | 4;

interface FortuneData {
  name: string;
  birth: string;
  time: string;
  leap: string;
  gender: string;
  question: string;
}

interface PaymentData {
  phoneNumber: string;
  email?: string;
  paymentMethod: "card" | "bank";
  accountInfo?: string; // 입금자명
}

function PaymentFlowPage() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState<PaymentStep>(1);
  // 각 단계별 입력값을 상위에서 관리
  const [fortuneData, setFortuneData] = useState<FortuneData>({
    name: "",
    birth: "",
    time: "????",
    leap: "SOLAR",
    gender: "MALE",
    question: "",
  });
  const [paymentData, setPaymentData] = useState<PaymentData>({
    phoneNumber: "",
    email: "",
    paymentMethod: "card",
    accountInfo: "",
  });

  // 결제 성공 시 주문정보 콘솔 출력
  useEffect(() => {
    if (currentStep === 4 && fortuneData && paymentData) {
      console.log("[주문정보] 사주정보:", fortuneData);
      console.log("[주문정보] 결제정보:", paymentData);
    }
  }, [currentStep, fortuneData, paymentData]);

  const handleStep1Complete = () => {
    setCurrentStep(2);
  };

  // Step2Payment에서 두 번째 인자로 이메일 또는 휴대폰 번호가 올 수 있음
  const handleStep2Complete = (
    paymentMethod: "card" | "bank",
    value: string,
    extraPhone?: string
  ) => {
    if (paymentMethod === "card") {
      setPaymentData((prev) => ({
        ...prev,
        phoneNumber: extraPhone || value,
        email: extraPhone ? value : undefined,
        paymentMethod: "card",
      }));
      setCurrentStep(4);
    } else {
      setPaymentData((prev) => ({
        ...prev,
        phoneNumber: extraPhone || value,
        email: extraPhone ? value : undefined,
        paymentMethod: "bank",
      }));
      setCurrentStep(3);
    }
  };

  // Step3에서 입금자명도 저장
  const handleStep3Complete = (accountInfoValue?: string) => {
    setPaymentData((prev) =>
      prev ? { ...prev, accountInfo: accountInfoValue } : prev
    );
    setCurrentStep(4);
  };

  const handleBack = () => {
    if (currentStep === 1) {
      navigate("/payment");
    } else {
      setCurrentStep((prev) => (prev - 1) as PaymentStep);
    }
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <Step1InputForm
            // value, onChange props 추가 필요 (컴포넌트 파일도 수정 필요)
            value={fortuneData}
            onChange={setFortuneData}
            onNext={handleStep1Complete}
            onBack={handleBack}
          />
        );
      case 2:
        return (
          <Step2Payment
            // value, onChange props 추가 필요 (컴포넌트 파일도 수정 필요)
            value={paymentData}
            onChange={setPaymentData}
            onNext={handleStep2Complete}
            onBack={handleBack}
            fortuneData={fortuneData}
          />
        );
      case 3:
        return (
          <Step3BankTransfer
            // value, onChange props 추가 필요 (컴포넌트 파일도 수정 필요)
            value={paymentData.accountInfo || ""}
            onChange={(val: string) =>
              setPaymentData((prev) => ({ ...prev, accountInfo: val }))
            }
            onNext={handleStep3Complete}
            onBack={handleBack}
            paymentData={paymentData}
            fortuneData={fortuneData}
          />
        );
      case 4:
        return (
          <Step4Complete paymentData={paymentData} fortuneData={fortuneData} />
        );
      default:
        return null;
    }
  };

  return (
    <main className="max-w-[716px] mx-auto bg-[#F9F9FC] flex flex-col pb-10 pt-10">
      {renderCurrentStep()}
    </main>
  );
}

export default PaymentFlowPage;
